import { useEffect, useRef } from "react";

export const useOnceEffect = (effect: () => void, condition = true, deps: unknown[] = []): void => {
	const done = useRef(false);

	useEffect(() => {
		if (condition && !done.current) {
			effect();
			done.current = true;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deps]);
};
